import moment from "moment";
import {
	ECRBRecordCode,
	ECRBRecordState,
	TCRBBackendRecord,
	TCRBCommonData,
	TCRBCommonFields,
} from "../@types";
import { EMARPOLDocuments, TMARPOLTank } from "../../marpol/@types";
import MARPOLModule from "../../marpol/operation.types";

export type TCRBItemO1 = {
	generalRemarks: string;
};

export type TCRBItemO2 = MARPOLModule.MissedEntryItem<TCRBBackendRecord>;

export type TCRBItemO3 = {
	nlsResidue: string;
	waiverIssued: string;
	pamPrescribes: string;
	dischargeRecording: string;
};

export type TCRBK0 = TCRBCommonFields &
	TCRBCommonData & {
		id: string;
		recordCode: ECRBRecordCode.CRBK0;
		itemO1: TCRBItemO1;
	};

export type TCRBK1 = TCRBCommonFields &
	TCRBCommonData & {
		id: string;
		recordCode: ECRBRecordCode.CRBK1;
		itemO2: TCRBItemO2;
	};

export type TCRBK2 = TCRBCommonFields &
	TCRBCommonData & {
		id: string;
		recordCode: ECRBRecordCode.CRBK2;
		itemO3: TCRBItemO3;
	};

export type TCRBK = TCRBK0 | TCRBK1 | TCRBK2;

const CRBK_DEFAULTS: { K0: TCRBK0; K1: TCRBK1; K2: TCRBK2 } = {
	K0: {
		id: "",
		_rev: "",
		marpolType: EMARPOLDocuments.CRB,
		state: ECRBRecordState.IDLE,
		selectedDate: moment().format("YYYY-MM-DD"),
		itemO1: {
			generalRemarks: "",
		},
		remarks: "",
		recordCode: ECRBRecordCode.CRBK0,
	},
	K1: {
		id: "",
		_rev: "",
		marpolType: EMARPOLDocuments.CRB,
		state: ECRBRecordState.IDLE,
		selectedDate: moment().format("YYYY-MM-DD"),
		remarks: "",
		recordCode: ECRBRecordCode.CRBK1,
		itemO2: {
			dateOfOriginalOperation: "",
			isAnMissedEntryRecord: true,
			missedRecord: undefined,
			receiptAttachment: " ",
		},
	},
	K2: {
		id: "",
		_rev: "",
		marpolType: EMARPOLDocuments.CRB,
		state: ECRBRecordState.IDLE,
		selectedDate: moment().format("YYYY-MM-DD"),
		remarks: "",
		recordCode: ECRBRecordCode.CRBK2,
		itemO3: {
			nlsResidue: "",
			waiverIssued: "",
			pamPrescribes: "",
			dischargeRecording: "",
		},
	},
};

export { CRBK_DEFAULTS };
